var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-rate',{attrs:{"show-text":_vm.element.config['show-text'],"allow-half":_vm.element.config['allow-half'],"count":_vm.element.config.max,"disabled":_vm.disabled || _vm.element.config.disabled},model:{value:(_vm.element.value),callback:function ($$v) {_vm.$set(_vm.element, "value", $$v)},expression:"element.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }